/* eslint-disable eqeqeq */
import { Component } from "react";
import { FaPhoneAlt, FaEnvelope, FaPlusCircle } from "react-icons/all";
import { NotesEntity } from "../CommonProps";
import { IBodyshopService } from "../UserService";
import moment from "moment";
import "./messages.scss";
import { Common, sortOrder, SortType } from "../CommonService";
import { IUser } from "./../CommonProps";
import {
  Avatar,
  AvatarBadge,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { createStandaloneToast } from "@chakra-ui/react";
import { Box } from "@chakra-ui/react";
import { BeatLoader } from "react-spinners";
import APIService from "../Services/APIService";
import { IBSAdonisService } from "../Services/IBSAdonisService";
import { NotesSuggestion } from "../modals/NotesSuggestion";

const toast = createStandaloneToast();
export interface MessageBoardProps {
  hideScreen: () => void;
  ibsService: IBodyshopService;
  ibsAdonisService: IBSAdonisService;
  estimateId: string;
  estimateNumber: number | string;
  notes: NotesEntity[];
  allUsers: IUser[];
  notesAdded: () => void;
  showHideLoader: (value: boolean) => void;
  newMessage: (value: boolean) => void;
  notesSuggestions: NotesSuggestion[] | [];
  estimateDetails?: any;
}
export interface MessageBoardState {
  messageText: string;
  notes: NotesEntity[];
  notesSuggestions: NotesSuggestion[] | [];
  propsNotes: NotesEntity[] | [];
  messageTypes: any[];
  sendingMessage: boolean;
}

export class MessageBoard extends Component<
  MessageBoardProps,
  MessageBoardState
> {
  private common = new Common();
  private customerTemplateId = "f9466b6c-80ee-4db1-8099-5bcf2a0ea1db";
  private adminTemplateId = "1fb65ba5-ddb5-47bf-8585-0dc55ca8c943";
  private apiService = new APIService();

  constructor(props: MessageBoardProps) {
    super(props);
    this.state = {
      messageText: "",
      propsNotes: [],
      notesSuggestions: [],
      notes: [],
      messageTypes: [],
      sendingMessage: false,
    };
    window.addEventListener("scroll", this.handleScroll, true);
  }

  chatOpenned() {
    if (this.state.notes?.length) {
      const lastMessage = this.state.notes
        .filter((message) => message.body)
        .slice(-1)[0].body;
      sessionStorage.setItem("last-note-displayed", lastMessage);
      this.props.newMessage(false);
    }
  }

  componentDidMount() {
    this.setState({
      propsNotes: this.getPropsNotes(),
      notesSuggestions: this.getNotesSuggestion(),
      sendingMessage: false,
    });
    setTimeout(() => {
      this.setNotes();
    }, 1000);
  }

  componentDidUpdate(preProps: MessageBoardProps) {
    if (
      preProps.notes != this.props.notes ||
      preProps.allUsers != this.props.allUsers
    ) {
      this.setState({
        propsNotes: this.getPropsNotes(),
        notesSuggestions: this.getNotesSuggestion(),
        sendingMessage: false,
      });
      setTimeout(() => {
        this.setNotes();
        const objDiv = document.getElementById("messages");
        if (objDiv) {
          objDiv.scrollTop = objDiv.scrollHeight;
        }
      }, 1000);
    }
  }

  handleScroll = (e: any) => {
    if (e.target?.classList?.contains("on-scrollbar") === false) {
      e.target?.classList?.add("on-scrollbar");
    } else {
      setTimeout(() => {
        e.target?.classList?.remove("on-scrollbar");
      }, 1000);
    }
  };

  sendTeamsNotification() {
    const currentUser = this.props.ibsService.currentUser.user;
    const htmlContent = `<p> <strong>Customer Message</strong> ${this.props.estimateNumber} <br> <strong>Customer: </strong> ${currentUser.name}<br> <strong>Email: </strong> ${currentUser.email} <br> <strong>Vehicle: </strong> ${this.props.estimateDetails?.vehicleDescription}<br> <strong>Rego: </strong> ${this.props.estimateDetails?.vehicleRegistration}<br> <strong>Message: </strong> ${this.state.messageText}<br> <strong>IBS:</strong> <a href="https://app.ibodyshop.com/#/Estimate/${this.props.estimateId}/header">link</a> </p>`;
    this.apiService.sendCustomerChatNotification(
      htmlContent,
      currentUser.email
    );
  }

  async addMessage() {
    this.setState({
      sendingMessage: true,
    });
    try {
      const content = this.state.messageTypes.find(
        (message) => message.id === this.customerTemplateId
      );
      const messagePayload = {
        message: content?.message
          ? content.message + " " + this.state.messageText
          : "" + this.state.messageText,
        estimateId: this.props.estimateId,
      };
      const res: any = await this.props.ibsAdonisService.addNotes(
        messagePayload
      );
      if (res.success) {
        toast({
          title: "Message sent",
          description:
            "We have successfully received your message. We are working on it and will be in contact shortly - maximum of 24h.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        this.props.notesAdded();
        this.sendTeamsNotification();
        this.setState({ messageText: "" });
      } else {
        toast({
          title: "Message Not sent",
          description: "Please try it later.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (ex) {
      toast({
        title: "Message Not sent",
        description: "Please try it later.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }

    this.setState({
      sendingMessage: false,
    });
  }

  setNotes() {
    const currentUser = this.props.ibsService.currentUser.user;

    const messageTypes = this.state.notesSuggestions.map(
      (item: NotesSuggestion) => {
        if (
          item.message.startsWith("{EstimateNumber}") &&
          this.props.estimateNumber !== ""
        ) {
          item.message = item.message.replace(
            "{EstimateNumber}",
            "" + this.props.estimateNumber
          );
        }
        item.isAdmin = this.adminTemplateId === item.id;
        return item;
      }
    );

    this.setState({ messageTypes });

    const filteredNotes = this.state?.propsNotes
      .filter((item: NotesEntity) => {
        return (
          !item.isArchived &&
          messageTypes.some((message) => item.body.includes(message.message))
        );
      })
      .map((item: NotesEntity) => {
        const message = messageTypes.find((message) =>
          item.body.startsWith(message.message)
        );

        if (message) {
          item.bodyMessage = item.body.substring(message.message.length).trim();
          item.isAdmin = message.isAdmin;
          const users = this.getUser(item);
          if (users.length > 0) {
            const userContactDetails = users[0].contactDetails;
            item.userImageId = message.isAdmin ? users[0].imageId || "" : "";
            item.userName = message.isAdmin
              ? userContactDetails.displayName || ""
              : currentUser.name;
            item.phoneNumber = message.isAdmin
              ? userContactDetails.businessPhone || ""
              : "";
            item.email = message.isAdmin
              ? userContactDetails.emailAddress || ""
              : currentUser.email;
          } else {
            item.userImageId = "";
            item.userName = "";
          }
        }
        return item;
      });

    const sortedNotes = this.common.getSortedDataWithKey(
      filteredNotes.filter((x: NotesEntity) => !x.isArchived),
      "created",
      sortOrder.asc,
      SortType.date
    );

    const lastNoteDisplayed = sessionStorage.getItem("last-note-displayed");
    const lastNewNote = sortedNotes.filter((note) => note.body).slice(-1)[0];

    if (
      lastNewNote &&
      lastNewNote.isAdmin &&
      lastNoteDisplayed !== lastNewNote?.body
    ) {
      this.props.newMessage(true);
    }

    if (sortedNotes.length > 0 && !lastNewNote?.isAdmin) {
      sortedNotes.push({
        bodyMessage:
          "We'll reach out to you within 24 hours. Feel free to close this chat and return later.",
        isAdmin: true,
        userName: "System",
      });
    }

    this.setState({
      notes: sortedNotes,
    });
  }

  getPropsNotes() {
    return this.props.notes;
  }

  getNotesSuggestion() {
    return this.props.notesSuggestions;
  }

  getUser(entity: NotesEntity) {
    return this.props.allUsers.filter(
      (x: IUser) => x?.id == entity?.createdByUserId
    );
  }

  render() {
    return (
      <div className={"w-100"}>
        <div className={"boardContent"}>
          <Box
            mb={6}
            overflowY={"auto"}
            overflowX={"hidden"}
            padding={"5px"}
            id="messages"
          >
            {this.state.notes.map((note) => (
              <div key={note.noteId}>
                <div
                  className={[
                    "comment",
                    !note.isAdmin
                      ? "isImportant"
                      : "includedInEstimatePrintout",
                  ].join(" ")}
                >
                  <Menu>
                    <MenuButton className="avatar_btn">
                      <Avatar
                        name={note.userName}
                        src={
                          this.props.ibsService.apiBaseUrl +
                          "/api/iBodyShop/GetUserImageBlob/" +
                          note.userImageId
                        }
                      >
                        <AvatarBadge bg="blue.700" boxSize="1.15em">
                          {" "}
                          <FaPlusCircle />
                        </AvatarBadge>
                      </Avatar>
                    </MenuButton>
                    {note.phoneNumber || note.email ? (
                      <>
                        {" "}
                        <MenuList>
                          {note.phoneNumber ? (
                            <>
                              <MenuItem
                                onClick={() =>
                                  window.open(
                                    "tel:" + note.phoneNumber,
                                    "_self"
                                  )
                                }
                              >
                                <Box mr={2}>
                                  <FaPhoneAlt />{" "}
                                </Box>{" "}
                                Call
                              </MenuItem>
                            </>
                          ) : null}
                          {note.email ? (
                            <>
                              <MenuItem
                                onClick={() =>
                                  window.open("mailTo:" + note.email)
                                }
                              >
                                <Box mr={2}>
                                  <FaEnvelope />{" "}
                                </Box>{" "}
                                E-mail
                              </MenuItem>
                            </>
                          ) : null}
                        </MenuList>
                      </>
                    ) : null}
                  </Menu>
                  <div className={"commentDetails"}>
                    <div className={"mText"}> {note.bodyMessage} </div>
                    <label className={"commentDate"}>
                      {" "}
                      {moment(note.created).format(
                        "DD/MM/YYYY hh:mm A"
                      )} by {note.userName}
                    </label>
                  </div>
                </div>
              </div>
            ))}
          </Box>

          <Box>
            <textarea
              value={this.state.messageText}
              style={{ padding: "10px" }}
              onChange={(e) =>
                this.setState({ messageText: e.currentTarget.value })
              }
              placeholder={"Type your message here"}
              className={"messageText"}
            />
            <Button
              colorScheme="blue"
              size="lg"
              float="right"
              isLoading={this.state.sendingMessage}
              onClick={() => this.addMessage()}
              disabled={!this.state.messageText || this.state.sendingMessage}
              spinner={<BeatLoader size={8} color="white" />}
            >
              Send
            </Button>
          </Box>
        </div>
      </div>
    );
  }
}
